import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';

import UsersSettings from '../UsersSettings/UsersSettings';
import RolesSettings from '../RolesSettings/RolesSettings';
import { hasAccess, resources, access } from 'utils/permissions';

const SettingsRoutes = ({ newUrl }) => {
  return (
    <>
      {hasAccess([resources.SETTINGS_USERS, access.READ]) && (
        <Route path={`${newUrl}/users`} exact>
          <UsersSettings />
        </Route>
      )}

      {hasAccess([resources.SETTINGS_ROLES, access.READ]) && (
        <Route path={`${newUrl}/roles`} exact>
          <RolesSettings />
        </Route>
      )}
    </>
  );
};

SettingsRoutes.propTypes = {
  newUrl: PropTypes.string.isRequired
};

export default SettingsRoutes;
